'use client';
import styles from './search-layout.module.scss';
import { type MouseEventHandler, type ReactNode } from 'react';
import Button from 'components/controls/buttons/button';
import CloseIcon from 'assets/icons/close-x.svg';
import FiltersIcon from 'assets/icons/filters.svg';
import classNames from 'node_modules/classnames';

const SearchLayout = ({
	results,
	controls,
	hideControls,
	handleCloseButton,
	handleOpenButton,
}: IProps) => {
	return (
		<div>
			<section
				className={classNames(
					styles.wrapper,
					!hideControls && styles.openControls,
				)}
				data-lock-page-mobile-only={!hideControls}
			>
				<div className={styles.controls}>
					{!hideControls && (
						<button className={styles.closeButton} onClick={handleCloseButton}>
							Close <CloseIcon />
						</button>
					)}
					<div className={styles.controlWrapper}>
						<div className={styles.scrollingContainer}>{controls}</div>
					</div>
				</div>
				<div className={styles.results}>{results}</div>
			</section>
			{hideControls && (
				<div className={styles.buttonWrapper}>
					<Button
						className={styles.filtersButton}
						appearance="secondary"
						onClick={handleOpenButton}
					>
						Filter <FiltersIcon />
					</Button>
				</div>
			)}
		</div>
	);
};

export interface IProps {
	controls?: ReactNode;
	handleCloseButton: MouseEventHandler;
	handleOpenButton: MouseEventHandler;
	hideControls?: boolean;
	results?: ReactNode;
}

export default SearchLayout;
